import { Footer } from "../../../components/index";
import { TopInnoTracks } from "../components/index";
import { NavBarTest } from "../../../components/NavBarTest";

export const TopInnovator = () => {
   document.title = "Venture Summit Digital Connect | Top Innovator";

   return (
      <div style={{ backgroundColor: "#191919" }}>
         <NavBarTest />
         <div className="to-banner" style={{ position: 'relative' }}>
            <img alt='top-innovator-banner' src={"./assets/media/top-inno-banner.png"} style={{ width: '100%' }} />
         </div>
         <TopInnoTracks />
         <div
            style={{
               display: "flex",
               flexDirection: "column",
               justifyContent: "center",
               textAlign: "center",
            }}
         >
         </div>
         <Footer />
      </div>
   );
};
